function loadAppComponent (path) {
  return () =>
    import(
      /* webpackChunkName: "app-view-[request]" */
      `@/views/app/${path}.vue`
    )
}

export default [
  {
    path: '/',
    redirect: '/dashboard/home',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard',
    component: loadAppComponent('Index'),
    redirect: '/dashboard/home',
    children: [
      {
        path: 'home',
        component: loadAppComponent('Dashboard'),
        name: 'dashboard.home',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'booking-catalogue',
        component: loadAppComponent('NewDashboard'),
        name: 'dashboard.booking-catalogue',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'charter',
        component: loadAppComponent('Charter'),
        name: 'dashboard.charter',
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'my-bookings',
        component: loadAppComponent('MyBookings'),
        name: 'dashboard.my-bookings',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'my-bookings/:bookingId',
        component: loadAppComponent('ViewBooking'),
        name: 'dashboard.view-booking',
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'wallet',
        component: loadAppComponent('Wallet'),
        name: 'dashboard.wallet',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'notifications',
        component: loadAppComponent('Notifications'),
        name: 'dashboard.notifications',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'booking-successful/:bookingId?',
        component: loadAppComponent('BookingSuccessful'),
        name: 'dashboard.booking-successful',
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'request-successful',
        component: loadAppComponent('CharterRequestSuccessful'),
        name: 'dashboard.request-successful',
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'verification-successful',
        component: loadAppComponent('VerifcationSuccessful'),
        name: 'dashboard.verification-successful',
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'account',
        component: loadAppComponent('account/Index'),
        redirect: 'account/profile',
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'profile',
            component: loadAppComponent('account/Profile'),
            name: 'dashboard.account.profile'
          },
          {
            path: 'password',
            component: loadAppComponent('account/Password'),
            name: 'dashboard.account.password'
          },
          {
            path: 'suggest-route',
            component: loadAppComponent('account/SuggestRoute'),
            name: 'dashboard.account.suggest-route'
          },
          {
            path: 'promo-codes',
            component: loadAppComponent('account/PromoCodes'),
            name: 'dashboard.account.promo-codes'
          },
/*          {
            path: 'trip-menu',
            component: loadAppComponent('account/TripMenu'),
            name: 'dashboard.account.trip-menu'
          },*/
          {
            path: 'support',
            component: loadAppComponent('account/Support'),
            name: 'dashboard.account.support'
          }
        ]
      }
    ],
  }
]
